var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongLianjie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.124 7.334L3.207 9.25a2.5 2.5 0 000 3.536v0a2.5 2.5 0 003.536 0l1.916-1.916M7.334 5.123L9.25 3.207a2.5 2.5 0 013.536 0v0a2.5 2.5 0 010 3.535L10.87 8.66M9.41 6.582L6.583 9.411",
    stroke: "#4C6AFF",
    strokeLinecap: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_lianjie.5e016d72.svg";
export { SvgTongyongLianjie as ReactComponent };